module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    ref: "baseball",
    attrs: {
      "id": "profile-dialog",
      "top": "10vh",
      "width": "64rem",
      "center": true,
      "show-close": true,
      "close-on-click-modal": true,
      "close-on-press-escape": true,
      "visible": _vm.showProfileDialog,
      "destroy-on-close": true,
      "append-to-body": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showProfileDialog = $event
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "profile"
    }
  }, [_c('div', {
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-top": "10%",
      "text-align": "center"
    }
  }, [_c('el-image', {
    staticStyle: {
      "border-radius": "15px"
    },
    attrs: {
      "id": "image",
      "src": _vm.imageSrc,
      "fit": 'cover'
    }
  }, [_c('div', {
    staticClass: "image-slot",
    attrs: {
      "slot": "error"
    },
    slot: "error"
  }, [_c('i', {
    staticClass: "el-icon-picture-outline"
  })])]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.initialProfile.identifier))])], 1), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "id": "visible-tabs",
      "stretch": true
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Demographics",
      "name": "demographics"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Campaigns & Surveys",
      "name": "campaigns"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Interactions",
      "name": "interactions"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Opt-in & Permission",
      "name": "optin"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "hidden-tabs"
    }
  }, [_c('el-tabs', {
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Demographics",
      "name": "demographics"
    }
  }, [_c('demographics-tab', {
    attrs: {
      "loading": _vm.$apollo.queries.profile.loading,
      "demographics": _vm.demographics
    },
    on: {
      "blacklist": _vm.handleBlacklistNugget,
      "remove": _vm.handleRemoveNugget
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Campaigns & Surveys",
      "name": "campaigns"
    }
  }, [_c('campaigns-and-surveys-tab', {
    attrs: {
      "loading": _vm.$apollo.queries.profile.loading,
      "campaigns": _vm.campaigns
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Interactions",
      "name": "interactions"
    }
  }, [_c('interactions-tab', {
    attrs: {
      "loading": _vm.$apollo.queries.profile.loading,
      "interactions": _vm.processedInteractions
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Opt-in",
      "name": "optin"
    }
  }, [_c('optins-tab', {
    attrs: {
      "loading": _vm.$apollo.queries.profile.loading,
      "optins": _vm.optins
    }
  })], 1)], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14cace51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/profiles/profile/DialogCard.vue
// module id = 3150
// module chunks = 3